<template>
    <section class="beta-access parallax-parent" id="getbeta">

        <ParallaxBlock unique-class="beta-access_dotes"
                       :speed="-0.1"
                       image="dotes_9x10"
        >
        </ParallaxBlock>

        <div class="description right-container">

            <p class="text is-small">
                We invite you to discuss the product and are ready to provide an early beta version
            </p>

        </div>

        <div class="form-container">

            <transition name="fade-up">
                <div class="thank-block" v-if="isFormSended">

                    <h2 class="is-small is-centered">Get beta access</h2>

                    <img src="@/assets/images/icons/CheckMark_large.svg" alt="large check mark">

                    <h3 class="is-small">Your request has <br> been sent. <br><br> Thank you!</h3>

                </div>
            </transition>

            <form v-if="!isFormSended" @submit.prevent="sendForm" id="beta_access_form">

                <h2 class="is-small is-centered">Get beta access</h2>

                <RadioGroup :options="['Individual', 'Corporate']"
                            v-model="formData.access_type"
                >
                </RadioGroup>

                <v-input :placeholder="formData.access_type == 'Individual' ? 'Name' : 'Company name'"
                         v-model="formData.name"
                >
                </v-input>

                <v-input placeholder="Email"
                         v-model="formData.email"
                >
                </v-input>

                <v-input placeholder="Phone number"
                         v-model="formData.phone"
                >
                </v-input>

                <Selectbox placeholder="Trading style"
                           v-model="formData.trading_style"
                           :options="tradingStyles"
                >
                </Selectbox>

                <Selectbox placeholder="Trading volume"
                           v-model="formData.trading_volume"
                           :options="tradingVolumes"
                >
                </Selectbox>

                <button type="submit" class="btn is-narrow">sign in</button>

            </form>

        </div>

    </section>
</template>

<script>
    export default {
        name: "BetaAccess",
        props: {
            subscribeType: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                formData: {
                    access_type: 'Individual',
                    name: '',
                    email: '',
                    phone: '',
                    trading_style: null,
                    trading_volume: null
                },

                types: ['Individual', 'Corporate'],
                tradingStyles: ['Position Trading', 'Day Trading', 'Swing Trading', 'Scalping'],
                tradingVolumes: ['< 5,000$ per month', '5,000$ - 25,000$ per month', '25,000% - 100,000$ per month', '100,000$ - 500,000$ per month', '> 500,000$ per month'],

                isFormSended: false
            }
        },
        methods: {
            sendForm() {
                const params = { 
                    beta_access_request: this.formData,
                    authenticity_token: this.$cookies.get('form_authenticity_token')
                }
                this.$axios.post("/beta_access_requests", params).then(() => { this.isFormSended = true })
            }
        },
        watch: {
            subscribeType(index) {

                this.formData.tradingVolume = this.tradingVolumes[index]

            }
        }
    }
</script>

<style>
    .fade-up-enter-active, .fade-up-leave-active {
        transition: .5s;
        opacity: 1;
        transform: translate(0px, 0px);
    }
    .fade-up-enter, .fade-up-leave-to {
        opacity: 0;
        transform: translate(0px, -40px);
    }
</style>